import React, { Fragment } from "react";
import propTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import get from "lodash/get";
import {
  IconButton,
  Divider,
  DialogContent,
  Button,
  TextField
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import DescriptionIcon from "@material-ui/icons/Description";
import CloseIcon from "@material-ui/icons/Close";
import noteSelector from "selectors/notes";
import {
  closeNotes,
  createNote,
  updateNote,
  listNotes
} from "store/state/note";
import { SlideLeft } from "components/Transitions/Slide";
import Dialog from "./styles/Dialog";
import DialogTitle from "./styles/Title";
import Note from "./Note";

const styles = theme => ({
  button: {
    margin: theme.spacing.unit
  }
});

class Notes extends React.Component {
  static propTypes = {
    model: propTypes.string,
    modelId: propTypes.number
  };

  static defaultProps = {
    model: null,
    modelId: null
  };

  state = {
    noteText: ""
  };

  componentDidUpdate(prevProps) {
    const { model, modelId } = this.props.note.modal;
    const { model: prevModel, modelId: prevModelId } = prevProps.note.modal;
    if (!model || !modelId) {
      return;
    }
    if (model === prevModel || modelId === prevModelId) {
      return;
    }
    if (!get(this.props, [model, modelId, "notes"])) {
      this.props.listNotes({ model, id: modelId });
    }
  }

  createNote = () => {
    const { model, modelId } = this.props.note.modal;
    const { noteText: note } = this.state;
    this.props.createNote({ note: { model, modelId, note } });
    this.setState({ noteText: "" });
  };

  resetNote = () => {
    this.setState({ noteText: "" });
    this.props.closeNotes();
  };

  handleNoteText = ({ target: { value: noteText } }) =>
    this.setState({ noteText });

  resetNoteText = () => this.setState({ noteText: "" });

  getNotesName = (model, modelId) => {
    const {
      fund,
      deal,
      quotes: { quotes }
    } = this.props;
    if (model === "fund") {
      return fund.funds[modelId].name;
    } else if (model === "deal") {
      return deal.deals[modelId].name;
    } else if (model === "quote") {
      return quotes[modelId].guaranty;
    }
    return null;
  };

  render() {
    const {
      notes,
      note: {
        modal: { model, modelId }
      },
      classes: { button: buttonClasses }
    } = this.props;
    const { noteText } = this.state;
    return (
      <div>
        <Dialog
          open={Boolean(model && modelId)}
          TransitionComponent={SlideLeft}
          onBackdropClick={this.resetNote}
        >
          <DialogTitle>
            <DescriptionIcon />Notes            
            <IconButton onClick={this.resetNote}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <Divider />
          <DialogContent>
            <TextField
              placeholder="Click here to add a new note..."
              value={noteText}
              onChange={this.handleNoteText}
              multiline
              fullWidth
              rows={2}
              rowsMax={4}
              margin="normal"
            />
            {noteText !== "" && (
              <Fragment>
                <Button
                  variant="raised"
                  color="primary"
                  onClick={this.createNote}
                  className={buttonClasses}
                >
                  Save
                </Button>
                <Button
                  variant="raised"
                  onClick={this.resetNoteText}
                  className={buttonClasses}
                >
                  Clear
                </Button>
              </Fragment>
            )}
            {notes.map(note => <Note key={note.id} note={note} />)}
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { note, fund, deal, quotes } = state;
  return { note, fund, deal, quotes, notes: noteSelector(state) };
};

export default compose(
  connect(
    mapStateToProps,
    { closeNotes, createNote, updateNote, listNotes }
  ),
  withStyles(styles)
)(Notes);
